import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

// Local
import { PaymentUtils } from './paymentUtils';
import { PaymentV2Response } from './payment';
import { AppConfiguration } from 'src/app/app.configuration';
import { PubqConfig, PubqConfigProvider } from '../pubq-config/pubq-config';
import { ContextProvider } from '../context/context';
import { Order } from '../order/order';

let appSettings = require("../../../../cordova-scripts/appsettings");


@Injectable({
    providedIn: "root"
})
export class VippsPaymentProvider {
    appBuild = "";
    config: PubqConfig;
    sub: Subscription;
    customUrlProtocol = AppConfiguration.customUrlProtocol;

    constructor(
        private contextProvider: ContextProvider,
        private pubqConfigProvider: PubqConfigProvider,
        private http: HttpClient,
        private paymentUtils: PaymentUtils
    ) {
        this.appBuild = appSettings && appSettings.version ? appSettings.version : 'N/A';

        this.sub = this.pubqConfigProvider.config.subscribe((x: PubqConfig) => {
            if (!x) return;
            this.config = x;
        });
    }

    ngOnDestroy() {
        if (this.sub) this.sub.unsubscribe();
    }

    async initiate(options: { user: any, paymentSource: any, order: Order }, idempotencyKey: string, orderId: string, app: boolean): Promise<PaymentV2Response> {
        let receiptOnly = false;
        try {
            receiptOnly = this.contextProvider.clientContext.appInfo.value.Context.receiptOnly;
            if (typeof options.order.receiptOnly !== undefined)
                receiptOnly = options.order.receiptOnly;
        } catch (error) {
            receiptOnly = false;
        }

        options.order.id = orderId;
        options.order.appType = 'app';

        const providerData = {
            mobileNumber: options.order.phoneNumber,
            isApp: app,
            skipLandingPage: !app,
            fallbackUrl: `${this.customUrlProtocol}?payment=vipps`
        }

        //testPayment needs to be removed (set to false!) when backend is ready
        const body = {
            idempotencyKey: idempotencyKey,
            userPaymentSource: options.paymentSource,
            order: options.order,
            paymentType: options.paymentSource.type,
            appVersion: this.appBuild && this.appBuild !== '' ? this.appBuild : 'N/A',
            routeName: options.order.client.routeName,
            receiptOnly,
            providerData,
            testPayment: false
        };

        // let url = `${this.config.ApiUrl}/payments/v1/idempotency/initiate`;
        // let resp = await this.http.post<PaymentV2Response>(url, body).toPromise();
        // return resp;

        console.dir(body);

        return this.paymentUtils.initiatePaymentWithRetry(body, this.config, this.http);
    }

    async charge(idempotencyKey: string, routeName: string): Promise<PaymentV2Response> {

        // Is not used for this payment provider, the charge method will be called 
        // from the providers callback in the backend.

        return null;
    }

    async verify(idempotencyKey: string, routeName: string, retry?: number): Promise<PaymentV2Response> {

        return this.paymentUtils.verifyPaymentWithRetry(idempotencyKey, routeName, this.config, this.http, retry);
    }

    async getQrCode(uri, token, routeName): Promise<any> {
        return new Promise<any>(async (resolve) => {

            try {
                const body = {
                    url: uri,
                    token,
                    format: 'png',
                    size: 300,
                    routeName
                };

                let url = `${this.config.ApiUrl}/payments/v1/vipps/qr`;
                let image = await this.http.post(url, body, { responseType: 'blob' }).toPromise();
                console.dir(image)

                // with file reader you will transform the file in a data url file;
                var reader = new FileReader();
                reader.readAsDataURL(image);

                reader.onloadend = () => {
                    // just putting the data url to img element
                    resolve(reader.result as string);
                }
            } catch (err) {
                resolve(null);
            }
        })
    }
}
